import storage from '@/plugins/vue-local-storage.js'
const defaultHistoryStorage = storage.fromNamespace('historyArray')

type useHistoryArrayOptions = {
  uniqueName?: string
  maxItems: number
  storage?: any //Custom storge
}

/**
 * Feature: Stores objects in a list and persist to cache
 *
 * Used by Location module to store recent searchs and execute the previous search when coming back from diagnostics (Link to module)
 */
export default function useHistoryArray(
  opts: useHistoryArrayOptions = {
    maxItems: 30,
  }
) {
  let historyStorage = opts.storage || defaultHistoryStorage
  const uniqueId = `array_` + opts.uniqueName || ''
  async function persistArr(arr) {
    arr
      .filter((i) => isObjInvalid(i))
      .forEach((i) => {
        console.warn('useHistoryArray ignoring empty object')
      })

    const filteredArray = (arr || [])
      .filter((i) => !isObjInvalid(i))
      .map((item) => {
        return JSON.parse(
          JSON.stringify(item, (key, value) => {
            if (typeof value === 'function') {
              console.warn('WARN', key, value)
              return undefined
            }
            return value
          })
        )
      })

    await historyStorage.setItem(
      uniqueId,
      filteredArray
      //(arr || []).filter((i) => !isObjInvalid(i))
    )
  }
  function isObjInvalid(obj: any) {
    return Object.keys(obj || {}).length === 0
  }
  async function pruneItems(
    arr: any[],
    disableSave: boolean = false,
    maxItems: number = null
  ) {
    maxItems = maxItems || opts.maxItems
    if (arr.length > maxItems) {
      arr.splice(0, arr.length - maxItems)
      if (!disableSave) {
        await persistArr(arr)
      }
    }
    return arr
  }
  async function getLastFromHistoryArray() {
    let arr = (await historyStorage.getItem(uniqueId)) || []
    await pruneItems(arr)
    arr = (await historyStorage.getItem(uniqueId)) || []
    return arr.length > 0 ? arr[arr.length - 1] : null
  }
  async function getReverseFirstWhere(whereHandler: Function) {
    let arr = (await historyStorage.getItem(uniqueId)) || []
    arr.reverse()
    for (let obj of arr) {
      if (whereHandler(obj)) {
        return obj
      }
    }
    return null
  }
  async function getAllFromHistoryArray() {
    let arr = (await historyStorage.getItem(uniqueId)) || []
    await pruneItems(arr)
    arr = (await historyStorage.getItem(uniqueId)) || []
    return arr
  }
  async function pushToHistoryArray(obj: any) {
    if (isObjInvalid(obj)) {
      console.warn(
        'useHistoryArray',
        'pushToHistoryArray',
        'ignoring empty object'
      )
    } else {
      //@ts-ignore
      console.debugVerbose(
        8,
        'useHistoryArray',
        opts.uniqueName,
        'pushToHistoryArray'
      )
    }
    let arr = (await historyStorage.getItem(uniqueId)) || []
    arr.push(obj)

    await pruneItems(arr, true)
    await persistArr(arr)
  }
  return {
    getReverseFirstWhere,
    getAllFromHistoryArray,
    getLastFromHistoryArray,
    pushToHistoryArray,
  }
}
